var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 1.5l-.08.015L7.5 2.55l-3-1.05-2.82.95a.252.252 0 00-.18.24v7.56c0 .14.11.25.25.25l.08-.015L4.5 9.45l3 1.05 2.82-.95a.252.252 0 00.18-.24V1.75c0-.14-.11-.25-.25-.25zM5 2.735l2 .7v5.83l-2-.7v-5.83zm-2.5.495L4 2.725v5.85l-1.5.58V3.23zm7 5.54L8 9.275V3.43l1.5-.58v5.92z",
    fill: "var(--text-blue)"
  })));
}
export default SvgMap;